export { default } from '@shikijs/themes/material-theme-darker'
